import { Col, Row } from 'react-bootstrap';
import logoEU from './logo_eu.png';
import useBreakpoint from './useBreakpoint';

const Footer = () => {
  const [size] = useBreakpoint();
  return (
    <> {(size !== "xs" && size !== "sm" && size !== "md") && ( <>
      <footer className="footer">
        <div className="d-flex justify-content-between pt-2 pt-xxl-2 pb-2">
            <div className="align-items-start" style={{marginTop: 20, marginLeft: 70}}>
                <img src={logoEU} alt="logo" style={{width: 300}}/>
                {/* <div className='footer-text'>The European Commission's support for the production of this 'publication' does not constitute an endorsement of the contents, which reflect the views only from the authors and the Commission cannot be held responsible for any use which may be made of the information contained therein.</div>  */}
            </div>
        </div>
        <div className="d-flex justify-content-between pb-2 align-items-start footer-text" style={{marginTop: 5, marginLeft: 73, marginBottom: 20}}>
            <div>The European Commission's support for the production of this 'publication' does not constitute an <br/> endorsement of the contents, which reflect the views only from the authors and the Commission cannot be <br/> held responsible for any use which may be made of the information contained therein. 
            </div>
        </div>
        
      </footer> </> )}
      {(size === "xs" || size === "sm" || size === "md") && ( <> 
        <footer className="footer">
        <Row style={{marginRight: 0, marginLeft: 0}}> <Col xs={4}>
            <div style={{marginTop: 20, marginLeft: 20}}>
                <img src={logoEU} alt="logo" style={{width: 200}}/>
            </div></Col>
            <Col xs={8}></Col>
        </Row>
        <Row className="footer-text" style={{marginRight: 0, marginLeft: 0}}>
            <div style={{marginTop: 20, marginBottom: 50, paddingLeft: 30, paddingRight: 10}}>The European Commission's support for the production of this 'publication' does not constitute an <br/> endorsement of the contents, which reflect the views only from the authors and the Commission cannot be <br/> held responsible for any use which may be made of the information contained therein. 
            </div>
        </Row>
        
      </footer>
      </> )}
    </>
  );
};

export default Footer;
